<table class="profile-info-table">
    <tr *ngIf="firstOffice?.country">
        <td><span class="fa fa-globe fa-font-18"></span></td>
        <td>
            {{ firstOffice.country.name }}
            <span class="cm-link" *ngIf="countries.names.length > 1" (click)="showFullList(LOCATION_TYPES.COUNTRY)"
                >+{{ countries.names.length - 1 }}</span
            >
        </td>
    </tr>
    <tr *ngIf="firstOffice?.region">
        <td><span class="fa fa-map-marker fa-font-18"></span></td>
        <td>
            {{ firstOffice.region.name }}
            <span class="cm-link" *ngIf="regions.names.length > 1" (click)="showFullList(LOCATION_TYPES.REGION)"
                >+{{ regions.names.length - 1 }}</span
            >
        </td>
    </tr>
    <tr *ngIf="firstOffice?.office">
        <td><span class="fa fa-building fa-font-16"></span></td>
        <td>
            {{ firstOffice.office.name }}
            <span class="cm-link" *ngIf="offices.names.length > 1" (click)="showFullList(LOCATION_TYPES.OFFICE)"
                >+{{ offices.names.length - 1 }}</span
            >
        </td>
    </tr>
</table>

<ng-template #fullListTemplate>
    <hr />
    <div class="location-full-list">
        <div *ngFor="let item of arr">{{ item }}</div>
    </div>
</ng-template>
